import { Grid } from '@mui/material';
import { GivelifyButton } from '../../button';
import { GivelifyIcon } from '../../icon';
import { GivelifyLabel } from '../../label';
import { useImageEditorContext } from '../context/ImageEditorContext';
import { ErrorWrapper } from '../style';

export type EditorErrorProps = {
    showContactSupport?: boolean;
    title: string;
    description: string;
    onDismiss: () => void;
    onSupport?: () => void;
};

export const EditorError: React.FCC<EditorErrorProps> = ({
    title,
    description,
    onDismiss,
    onSupport,
    showContactSupport,
}) => {
    const { copy } = useImageEditorContext();

    return (
        <ErrorWrapper>
            <Grid container flexWrap="nowrap" gap="8px">
                <Grid item>
                    <GivelifyIcon variant="warning-triangle" />
                </Grid>
                <Grid item className="content">
                    <GivelifyLabel text={title} variant="body2B" />
                    <GivelifyLabel text={description} variant="body2" />
                </Grid>
            </Grid>
            <div className="actions">
                <GivelifyButton
                    disableRipple
                    className="action dismiss"
                    data-testid="gvl-ntf-action-dismiss"
                    onClick={onDismiss}
                    size="small"
                    text={copy.dismiss}
                    variant="ghost"
                />
                {showContactSupport && (
                    <GivelifyButton
                        disableRipple
                        className="action contact"
                        data-testid="gvl-ntf-action-dismiss"
                        onClick={onSupport}
                        size="small"
                        text={copy.support}
                        variant="ghost"
                    />
                )}
            </div>
        </ErrorWrapper>
    );
};
